module.exports = __webpack_public_path__ + "static/media/cov_wor_org.23f19ddc.png";